import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import Modal from 'components/Common/MUIModal/Modal';
import ModalHeader from 'components/Common/MUIModal/ModalHeader';
import ModalBody from 'components/Common/MUIModal/ModalBody';
import ProductSheetBody from './ProductSheetBody';
import Button from 'components/UI/Buttons/Button/Button';
import Loading from 'components/Common/Loading/Loading';
import useProductStatic from 'hooks/ProductPageV2/useProductStatic';

import styles from './ProductSheetModal.module.scss';

type Props = {
  onClosed: () => void;
  url: string;
};

export default function ProductSheetModal({
  onClosed,
  url,
}: Props): JSX.Element | null {
  const { t } = useTranslation('checkout');
  const [isOpen, setOpen] = useState(true);
  const [color, setColor] = useState<string>();
  const { data, isLoading, error } = useProductStatic(
    url,
    color,
    undefined,
    undefined,
    false
  );

  function handleClose(e?: SyntheticEvent) {
    e?.preventDefault();
    setOpen(false);
  }

  if (isLoading) {
    return <Loading loading />;
  }

  return (
    <Modal
      open={isOpen}
      className={classNames(styles.modal, error && styles.hasError)}
      classes={{ innerContainer: !error ? styles.modalContainer : undefined }}
      onCloseClickAway={handleClose}
      onClosed={onClosed}
      disableRestoreFocus
    >
      <ModalHeader onClose={handleClose} className={styles.modalHeader}>
        <Button className={styles.backLink} onClick={handleClose}>
          <ArrowBackIosIcon className={styles.icon} />
          <span>{t('BACK_TO_CART')}</span>
        </Button>
      </ModalHeader>
      {data && (
        <ProductSheetBody
          formattedProduct={data}
          color={color}
          setColor={setColor}
          onClose={() => setOpen(false)}
        />
      )}
      {error && (
        <ModalBody bottomDivider={false}>
          <p>{t('MODAL_PRODUCT_ERROR_MESSAGE')}</p>
        </ModalBody>
      )}
    </Modal>
  );
}
